export default __webpack_public_path__ + "static/media/Mortiferous Helm.ae6bec26.jpg";